"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLocaleConfigHook = exports._LocalizeProvider = exports._useLocalizeContext = void 0;
const react_1 = require("react");
const localizeContext = (0, react_1.createContext)("");
const _useLocalizeContext = () => (0, react_1.useContext)(localizeContext);
exports._useLocalizeContext = _useLocalizeContext;
exports._LocalizeProvider = localizeContext.Provider;
const getLocaleConfigHook = (allConfigurations) => () => {
    const locale = (0, react_1.useContext)(localizeContext);
    return allConfigurations[locale];
};
exports.getLocaleConfigHook = getLocaleConfigHook;
